<template>
  <div id="app">
    <div v-bind:class="{ open: isNavOpen }">
      <div id="wrap" class="flex flex-column top">
        <header id="header" class="flex flex-align">
          <h1 class="logo"><a href="/"><img src="./assets/img/logo.svg" class="img-responsive" alt="DAYNEEDS"></a></h1>
          <div id="navBtn">
            <a v-on:click="navToggle" href="javascript:void(0);">
              <div class="top-bar"></div>
              <div class="middle-bar"></div>
              <div class="bottom-bar"></div>
            </a>
          </div>
          <nav id="gNavi" class="flex flex-align flex-center">
            <ul id="gNaviList" class="flex">
              <li>
                <ul v-if="isTopPage">
                  <li><a href="/news" class="opacity">NEWS</a></li>
                  <li><a href="#" class="opacity" v-on:click="navToggle" v-scroll-to="toService">SERVICES</a></li>
                  <li><a href="#" class="opacity" v-on:click="navToggle" v-scroll-to="toVision">VISION</a></li>
                  <li><a href="#" class="opacity" v-on:click="navToggle" v-scroll-to="toAbout">ABOUT</a></li>
                </ul>
                <ul v-else>
                  <li><a href="/news" class="opacity">NEWS</a></li>
                  <li><a href="/#service" class="opacity">SERVICES</a></li>
                  <li><a href="/#vision" class="opacity">VISION</a></li>
                  <li><a href="/#about" class="opacity">ABOUT</a></li>
                </ul>
              </li>
              <li>
                <ul v-if="isTopPage">
                  <li><a href="#" class="opacity" v-on:click="navToggle" v-scroll-to="toPolicy">POLICY</a></li>
                  <li><a href="#" class="opacity" v-on:click="navToggle" v-scroll-to="toHistory">HISTORY</a></li>
                  <li><a href="#" class="opacity" v-on:click="navToggle" v-scroll-to="toRecruit">RECRUIT</a></li>
                  <li><a href="/contact" class="opacity">CONTACT</a></li>
                </ul>
                <ul v-else>
                  <li><a href="/#policy" class="opacity">POLICY</a></li>
                  <li><a href="/#history" class="opacity">HISTORY</a></li>
                  <li><a href="/#recruit" class="opacity">RECRUIT</a></li>
                  <li><a href="/contact" class="opacity">CONTACT</a></li>
                </ul>
              </li>
            </ul>
          </nav>
        </header>
        <main id="contents">
          <router-view/>
        </main>
        <footer id="footer">
          <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
            <symbol id="svg-arrow-right" viewBox="0 0 8 14"><path d="M1,1c0,0,6,6,6,6l-6,6"></path></symbol>
          </svg>
          <transition name="fade">
            <div id="pagetop" v-on:click="scrollTop" v-show="showPageTop" v-scroll="handleScroll">
              <a href="javascript:void(0);">
                <div class="arrow-box">
                  <svg class="arrow-right">
                    <use xlink:href="#svg-arrow-right"></use>
                  </svg>
                </div>
              </a>
            </div>
          </transition>
          <div id="ftInner">
            <div class="flex flex-reverse">
              <ul id="ftNavi" class="flex">
                <li class="order1">
                  <dl>
                    <dt>SERVICES</dt>
                    <dd>
                      <ul>
                        <li><a v-bind:href="giftissueUrl" target="_blank" rel="noopener" class="opacity">Giftissue <i class="fas fa-external-link-alt"></i></a></li>
                        <li><a v-bind:href="kinkenExUrl" target="_blank" rel="noopener" class="opacity">金券買取EX <i class="fas fa-external-link-alt"></i></a></li>
                      </ul>
                    </dd>
                  </dl>
                </li>
                <li class="order3">
                  <dl>
                    <dt>ABOUT</dt>
                    <dd class="flex">
                      <ul v-if="isTopPage">
                        <li><a href="#" class="opacity" v-scroll-to="toAbout">会社概要</a></li>
                        <li><a href="#" class="opacity" v-scroll-to="toHistory">沿革</a></li>
                        <li><a href="#" class="opacity" v-scroll-to="toVision">企業理念</a></li>
                      </ul>
                      <ul v-else>
                        <li><a href="/#about" class="opacity">会社概要</a></li>
                        <li><a href="/#history" class="opacity">沿革</a></li>
                        <li><a href="/#vision" class="opacity">企業理念</a></li>
                      </ul>
                      <ul>
                        <li><a href="/news" class="opacity">ニュース</a></li>
                        <li><a href="/contact" class="opacity">お問い合わせ</a></li>
                        <!--<li><a href="/#" class="opacity">個人情報保護方針</a></li>-->
                      </ul>
                    </dd>
                  </dl>
                </li>
                <li class="order2">
                  <dl>
                    <dt>RECRUIT</dt>
                    <dd>
                      <ul>
                        <li><a v-bind:href="greenUrl" target="_blank" rel="noopener" class="opacity">Green <i class="fas fa-external-link-alt"></i></a></li>
                        <li><a v-bind:href="wantedlyUrl" target="_blank" rel="noopener" class="opacity">Wantedly <i class="fas fa-external-link-alt"></i></a></li>
                      </ul>
                    </dd>
                  </dl>
                </li>
              </ul>
              <div class="logo"><img src="./assets/img/logo-w.svg" class="img-responsive" alt="DAYNEEDS"></div>
            </div>
            <p id="copyright"><small>&copy; DAYNEEDS, Inc.</small></p>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        greenUrl: process.env.VUE_APP_GREENJAPAN,
        wantedlyUrl: process.env.VUE_APP_WANTEDLY,
        giftissueUrl: process.env.VUE_APP_GIFTISSUE,
        kinkenExUrl: process.env.VUE_APP_KINKENEX,
        isNavOpen: false,
        showPageTop: false,
        toService: '#service',
        toVision: '#vision',
        toAbout: '#about',
        toPolicy: '#policy',
        toHistory: '#history',
        toRecruit: '#recruit'
      }
    },
    computed: {
      isTopPage: function () {
        return this.$route.name === 'Top'
      }
    },
    methods: {
      navToggle: function () {
        this.isNavOpen = !this.isNavOpen
        return this.isNavOpen
      },
      scrollTop: function () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      },
      handleScroll: function (evt, el) {
        this.showPageTop = window.scrollY > 700
      }
    }
  }
</script>

<style>
  @import "./assets/css/layout.css";

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
